import { Injectable } from '@angular/core';
import { Observable, Subject, filter } from 'rxjs';

export type EventName = string;
export type EventPayload = any;

export interface Event {
  name: EventName;
  payload?: EventPayload;
}

@Injectable({
  providedIn: 'root'
})
export class EventBusService {
  private eventSubject = new Subject<Event>();
  private eventObservers: { [key: string]: Subject<any> } = {};

  constructor() { }

  /**
   * Emit an event with optional payload
   */
  emit(name: EventName, payload?: EventPayload): void {
    this.eventSubject.next({ name, payload });
  }

  /**
   * Subscribe to all events
   */
  on(): Observable<Event>;
  /**
   * Subscribe to specific event by name
   */
  on(name: EventName): Observable<EventPayload>;
  /**
   * Implementation
   */
  on(name?: EventName): Observable<any> {
    if (name) {
      if (!this.eventObservers[name]) {
        this.eventObservers[name] = new Subject<any>();
        this.eventSubject
          .pipe(
            filter(event => event.name === name)
          )
          .subscribe(event => this.eventObservers[name].next(event.payload));
      }
      return this.eventObservers[name].asObservable();
    }
    return this.eventSubject.asObservable();
  }

  /**
   * Unsubscribe from event
   */
  off(name: EventName): void {
    if (this.eventObservers[name]) {
      this.eventObservers[name].complete();
      delete this.eventObservers[name];
    }
  }

  /**
   * Clear all subscriptions
   */
  clear(): void {
    Object.keys(this.eventObservers).forEach(key => {
      this.eventObservers[key].complete();
    });
    this.eventObservers = {};
  }
}
